import React from "react";
import { HowItWork } from "../components/home/how-it-work";
import FeaturedProperties from "../components/home/featured-properties";
import DownloadApp from "../components/home/download-app";
import Testimonials from "../components/home/testimonials";
import FaqSection from "../components/home/faq-section";
import HomeBlogs from "../components/home/home-blogs";
import { Helmet } from "react-helmet-async";
import aboutImage from "../assets/images/why-choose-us.png";
import ownerCta from "../assets/images/owner-cta.png";
import ownerCta1 from "../assets/images/owner-cta-1.png";
import HSRLayout from "../assets/images/areas/hsr.png";
import BTMLayout from "../assets/images/btm-layout.png";
import ElectronicCity from "../assets/images/areas/electronic-city.png";
import Whitefield from "../assets/images/areas/whitefield.png";
import Koramangala from "../assets/images/koramangala.png";
import Marathahalli from "../assets/images/areas/marathahali.png";
import Mahadevpura from "../assets/images/areas/mahadevpura.png";
import SarjapurRoad from "../assets/images/areas/sarjapura.png";
import { Link } from "react-router-dom";
import Banner from "../components/home/banner";
import NewlyArrivedProperties from "../components/home/newly-arrived-property";
import FastSellingProperties from "../components/home/fast-selling-properties";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileScreenButton } from "@fortawesome/free-solid-svg-icons";
import WhyChooseSection from "../components/common/WhyChooseSection";
import HomePromoPopups from "../components/home/home-promo-popups";
import ReflectionsPromoBanner from "../components/home/reflections-promo-banner";

const HomePage = () => {
  const locations = [
    {
      name: "HSR Layout",
      thumbImage: HSRLayout,
      pageurl: "rent/flats-for-rent-in-hsr-layout-bangalore",
      link: "hsr-layout",
      hoverContent:
        "Affordable 1BHK & 2BHK flats for rent in HSR Layout – Find your perfect apartment with werentt.",
    },
    {
      name: "BTM Layout",
      thumbImage: BTMLayout,
      pageurl: "rent/rooms-for-rent-in-btm-layout-bangalore",
      link: "btm-layout",
      hoverContent:
        "Find your perfect home near everything you love in BTM Layout with werentt.",
    },
    {
      name: "Electronic City",
      thumbImage: ElectronicCity,
      pageurl: "rent/flats-for-rent-in-electronic-city-bangalore",
      link: "electronic-city",
      hoverContent:
        "Rent 1BHK and 2BHK apartments in Electronic City – Prime location flats available!",
    },
    {
      name: "Whitefield",
      thumbImage: Whitefield,
      pageurl: "rent/rooms-for-rent-in-whitefield-bangalore",
      link: "whitefield",
      hoverContent:
        "Spacious 1BHK and 2BHK flats for rent in Whitefield – Premium apartments listed by werentt.",
    },
    {
      name: "Koramangala",
      thumbImage: Koramangala,
      pageurl: "rent/rooms-for-rent-in-koramangala-bangalore",
      link: "koramangala",
      hoverContent:
        "Style, social life, and serenity—get it all in Koramangala with werentt rentals. Book your ideal apartment today.",
    },
    {
      name: "Marathahalli",
      thumbImage: Marathahalli,
      pageurl: "rent/flats-for-rent-in-marathahalli-bangalore",
      link: "marathahalli",
      hoverContent:
        "Seamless city access and cozy living with rentals in Marathahalli by werentt.",
    },
    {
      name: "Mahadevapura",
      thumbImage: Mahadevpura,
      pageurl: "rent/rooms-for-rent-in-mahadevapura-bangalore",
      link: "mahadevapura",
      hoverContent:
        "Find budget-friendly 1BHK & 2BHK flats for rent in Mahadevpura – Available now on werentt.",
    },
    {
      name: "Sarjapur Road",
      thumbImage: SarjapurRoad,
      pageurl: "rent/rooms-for-rent-in-sarjapur-road-bangalore",
      link: "sarjapur-road",
      hoverContent:
        "Premium 1BHK & 2BHK apartments for rent on Sarjapur Road – Browse our listings today.",
    },
  ];
  // console.log("locations", locations);
  return (
    <>
      <Helmet>
        <title>
          Flats and Apartments for Rent in Bangalore | Semi furnished & Fully Furnished | Werentt
          {/* Flats and Apartments for Rent in Bangalore | Rent House | Werentt{" "} */}
        </title>
        <meta
          name="description"
          content="Planning to rent a house in Bangalore? Rent 1BHK, 2BHK- semi furnished or full furnished flats or apartments from Werentt today! Contact to know more."
        />
        <meta
          name="keywords"
          content="rental properties in Bangalore, apartments for rent in Bangalore, villas for rent in Bangalore, rental homes in Bangalore, WeRentt, houses for rent in Bangalore, Flats for rent in Bangalore, property listings in Bangalore, Houses for lease in Bangalore, Apartments for lease in Bangalore, Flats for lease in Bangalore, affordable rentals in Bangalore, rental marketplace in Bangaloreflat rent Bangalore, rental properties Bangalore , rental flat in Bangalore , flat on rent in Bangalore, no brokerage house for rent in Bangalore, fully furnished house for rent Bangalore, fully furnished flat for rent Bangalore ."
        />
        <link rel="canonical" href="https://www.werentt.com/" />
      </Helmet>

      <div className="main-wrapper">
        <HomePromoPopups />
        <Banner />
        <ReflectionsPromoBanner />
        <NewlyArrivedProperties />
        <FastSellingProperties />

        <FeaturedProperties />
        {/* <CityListing /> */}
        <WhyChooseSection />
        <section className="located-in pt-5">
          <div className="container">
            <div className="row location-card-row">
              <div className="col-12">
                <div className="section-heading align-items-start">
                  <h2>
                    {" "}
                    Preferred residential areas in Bangalore for renting or
                    Investing
                  </h2>
                  <p>Find your tribe, live your life</p>
                </div>
              </div>
              {locations?.map((location, index) => (
                <div className="col-6 col-sm-6 col-md-4 col-lg-3">
                  <Link
                    className="located-in-card"
                    // to={`rent/flats-for-rent-in-${location.link
                    //   .toLowerCase()
                    //   .replace(/\s+/g, "-")}-bangalore`}
                    to={location.pageurl}
                    target="_blank"
                  >
                    <div className="located-in-thumb">
                      <img src={location.thumbImage} alt="located" />
                      <div className="hover-content">
                        <p>{location.hoverContent}</p>
                      </div>
                    </div>
                    <h3>{location.name}</h3>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </section>
        <Testimonials />

        <DownloadApp />
        <section className="list-property-rent">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-12 col-xl-10 mx-auto">
                <div className="section-heading align-items-start">
                  <h2>Want to rent your house or flat ?</h2>
                </div>
                <div className="list-prop-card">
                  <h3>
                    Connect with WeRentt today <br /> and rent it today.
                  </h3>
                  <Link
                    className=" btn btn-primary d-inline-block rounded "
                    to={"list-your-property"}
                  >
                    Rent your Property
                  </Link>
                  <div className="image-element-1">
                    <img src={ownerCta} alt="cta" />
                  </div>
                  <div className="image-element-2">
                    <img src={ownerCta1} alt="cta" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <FaqSection />
        <HomeBlogs />
        {/* <SocialMedia /> */}
      </div>
      {/* <div className="progress-wrap active-progress">
        <svg className="progress-circle svg-content" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div> */}
    </>
  );
};

export default HomePage;
